import "./Legal.module.css";
import Navigation from "@/reusable_sections/Header";
import Privacy from "./sections/Privacy";
import Disclaimer from "./sections/Disclaimer";
import Footer from "@/reusable_sections/Footer";
export default function LegalPage() {
  return <div>
      <Navigation />
      <Privacy />
      <Disclaimer />
      <Footer />
    </div>;
}